// extracted by mini-css-extract-plugin
module.exports = {"subSectionHeading":"_10xVV"};